<template>
  <div class="user-item">
    <NouImageBox class="user-item__avatar" :url="avatarUrl" />
    <h2 class="g-title user-item__name g-font-mid">{{ name || '-' }}</h2>
    <p class="user-item__ont">{{ ont }}</p>
  </div>
</template>

<script>

import { getUserAvatar } from '@/utils/business';

export default {
  name: 'UserItem',
  props: {
    avatar: {
      type: String,
      require: true,
    },
    name: {
      type: String,
      require: true,
    },
    ont: {
      type: String,
      require: true,
    },
  },
  computed: {
    avatarUrl() {
      return getUserAvatar(this.avatar);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .user-item {
    height: 40px;
    overflow: hidden;
  }

  .user-item__avatar {
    float: left;
    box-sizing: border-box;
    margin-right: 10px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid var(--border-common);
  }

  .user-item__name {
    margin-top: 4px;
    font-size: $font-size-base;
    line-height: 14px;
  }

  .user-item__ont {
    margin-top: 6px;
    font-size: $font-size-sm;
    line-height: 12px;
    color: var(--color-content);
    white-space: nowrap;
    overflow: auto;
  }
</style>
